import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { WhatsappTemplateMessageContent } from './models/whatsapp-template-message-content.model';
import { WhatsappTemplateButtonTypeEnum } from 'src/app/parameters/message-templates/whatsapp-templates/shared/models/whatsapp-template-button-type.enum';

@Component({
  selector: 'app-message-whatsapp-template',
  templateUrl: './message-whatsapp-template.component.html',
  styleUrls: ['./message-whatsapp-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageWhatsappTemplateComponent implements OnInit {
  @Input() message: WhatsappTemplateMessageContent;
  templateDisplayedBS: BehaviorSubject<FormGroup> = new BehaviorSubject(null);

  constructor() {}

  ngOnInit(): void {
    const form: FormGroup = new FormGroup({
      header: new FormGroup({
        text: new FormControl(),
        type: new FormControl(),
        media_type: new FormControl(),
        media_url: new FormControl(),
        filename: new FormControl(),
      }),
      body: new FormControl({}),
      buttons: new FormArray([]),
      footer: new FormControl(),
    });

    const { header, body, footer, buttons } = this.message;
    (buttons || []).forEach(button => {
      if (
        [WhatsappTemplateButtonTypeEnum.COPY_CODE, WhatsappTemplateButtonTypeEnum.URL].includes(button.type) &&
        !Array.isArray(button.example)
      ) {
        button.example = [button.example];
      }
      const buttonForm = new FormGroup({
        text: new FormControl(),
        type: new FormControl(),
        url: new FormControl(),
        example: new FormArray([]),
      });
      buttonForm.patchValue(button);
      (buttonForm.get('example') as FormArray).push(new FormControl(button.example ? button.example[0] : ''));
      (form.get('buttons') as FormArray).push(buttonForm);
    });

    if (header) {
      const { text, headerMediaUrl, headerMediaFilename, type, media_type } = header;
      form.get('header').setValue({
        text: text || '',
        type: type || 'text',
        media_type: media_type || null,
        media_url: headerMediaUrl || null,
        filename: headerMediaFilename || null,
      });
    }

    form.patchValue({ body, footer });
    this.templateDisplayedBS.next(form);
  }
}
